// @ts-nocheck
export const REACT_APP_API_ROOT: string = process.env.REACT_APP_API_ROOT;